import React from "react";
import { Query, Mutation } from "react-apollo";
import { Rate, Input, Button, message, Spin } from "antd";

import CreateOrderRating from "../../GraphQL/Mutation/CreateOrderRating";
import GetOrderRating from "../../GraphQL/Query/GetOrderRating";
// import GetOrderRating from "../../GraphQL/Query/GetOrderRating";

const { TextArea } = Input;

class OrderRating extends React.Component {
  state = {
    rating: 0,
    comments: ""
  };

  handleChangeRating = value => {
    this.setState({ rating: value });
  };

  handleChange = e => {
    const { name, value } = e.target;
    this.setState({ [name]: value });
  };

  onSubmitRate = (mutate, refetch) => {
    const { orderId, order } = this.props;
    const { rating, comments } = this.state;
    mutate({
      variables: {
        orderId,
        partnerId: order.partnerAssignedId,
        rating,
        comments: comments || null
      }
      //   refetchQueries: [
      //     {
      //       query: GetOrderRating,
      //       variables: { orderId }
      //     }
      //   ],
      //   update: (proxy, { data: { updateOrderStatus } }) => {
      //     const query = GetOrderRating;
      //     const variables = { orderId };
      //     const data = proxy.readQuery({
      //       query,
      //       variables
      //     });

      //     proxy.writeQuery({ query, data });
      //   }
    }).then(() => {
      refetch({ orderId });
      message.success("¡Gracias por enviar tu valoración del servicio!");
    });
  };

  render() {
    const { orderId } = this.props;
    const { rating, comments } = this.state;

    return (
      <Query
        query={GetOrderRating}
        variables={{ orderId }}
        fetchPolicy="cache-and-network"
      >
        {({ loading, error, data, refetch }) => {
          if (loading) return <Spin />;
          if (error) return <p>Error :(</p>;
          const { getOrderRating: orderRate = {} } = data;

          return (
            <Mutation mutation={CreateOrderRating}>
              {mutate =>
                !orderRate ? (
                  <div>
                    <Rate
                      allowHalf
                      onChange={this.handleChangeRating}
                      value={rating}
                    />
                    <TextArea
                      name="comments"
                      rows={4}
                      placeholder="Ingresa tus comentarios (opcional)"
                      onChange={this.handleChange}
                      value={comments}
                    />
                    <Button
                      type="primary"
                      style={{ marginTop: 5 }}
                      onClick={() => this.onSubmitRate(mutate, refetch)}
                    >
                      Enviar valoración
                    </Button>
                  </div>
                ) : (
                  <div>
                    <Rate disabled value={orderRate.rating} />
                    <div>{orderRate.comments}</div>
                  </div>
                )
              }
            </Mutation>
          );
        }}
      </Query>
    );
  }
}

export default OrderRating;



// WEBPACK FOOTER //
// ./src/Components/Orders/OrderRating.js